@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.events.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.events.resources/"

@delegate:ResourceContentHash(1_829_074_531)
internal val Res.string.events_am: StringResource by lazy {
      StringResource("string:events_am", "events_am", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10, 25),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 21),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.events_back_a11y: StringResource by lazy {
      StringResource("string:events_back_a11y", "events_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 36, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32, 32),
      ))
    }

@delegate:ResourceContentHash(-2_006_744_691)
internal val Res.string.events_date_time_format: StringResource by lazy {
      StringResource("string:events_date_time_format", "events_date_time_format", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 77, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 65, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65, 71),
      ))
    }

@delegate:ResourceContentHash(1_569_372_406)
internal val Res.string.events_detail_about: StringResource by lazy {
      StringResource("string:events_detail_about", "events_detail_about", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 149, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 137, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137, 51),
      ))
    }

@delegate:ResourceContentHash(1_975_403_400)
internal val Res.string.events_detail_to: StringResource by lazy {
      StringResource("string:events_detail_to", "events_detail_to", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 225, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 205, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189, 44),
      ))
    }

@delegate:ResourceContentHash(-984_359_507)
internal val Res.string.events_detail_when: StringResource by lazy {
      StringResource("string:events_detail_when", "events_detail_when", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 270, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 250, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 234, 34),
      ))
    }

@delegate:ResourceContentHash(2_136_458_299)
internal val Res.string.events_detail_where: StringResource by lazy {
      StringResource("string:events_detail_where", "events_detail_where", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 309, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 285, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 269, 35),
      ))
    }

@delegate:ResourceContentHash(1_352_359_243)
internal val Res.string.events_details_external: StringResource by lazy {
      StringResource("string:events_details_external", "events_details_external", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 349, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 317, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 305, 51),
      ))
    }

@delegate:ResourceContentHash(1_834_492_087)
internal val Res.string.events_empty_description: StringResource by lazy {
      StringResource("string:events_empty_description", "events_empty_description", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 417, 192),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 385, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 357, 112),
      ))
    }

@delegate:ResourceContentHash(-1_386_474_813)
internal val Res.string.events_empty_title: StringResource by lazy {
      StringResource("string:events_empty_title", "events_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 610, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 514, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 470, 46),
      ))
    }

@delegate:ResourceContentHash(-724_818_954)
internal val Res.string.events_error: StringResource by lazy {
      StringResource("string:events_error", "events_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 677, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 577, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 517, 56),
      ))
    }

@delegate:ResourceContentHash(241_812_897)
internal val Res.string.events_featured: StringResource by lazy {
      StringResource("string:events_featured", "events_featured", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 806, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 698, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 618, 43),
      ))
    }

@delegate:ResourceContentHash(-1_435_106_176)
internal val Res.string.events_featured_section: StringResource by lazy {
      StringResource("string:events_featured_section", "events_featured_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 762, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 650, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 574, 43),
      ))
    }

@delegate:ResourceContentHash(-1_256_663_562)
internal val Res.string.events_filter_all: StringResource by lazy {
      StringResource("string:events_filter_all", "events_filter_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 858, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 750, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 662, 29),
      ))
    }

@delegate:ResourceContentHash(-2_045_174_785)
internal val Res.string.events_filter_business: StringResource by lazy {
      StringResource("string:events_filter_business", "events_filter_business", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 892, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 784, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 692, 42),
      ))
    }

@delegate:ResourceContentHash(277_149_615)
internal val Res.string.events_filter_culture: StringResource by lazy {
      StringResource("string:events_filter_culture", "events_filter_culture", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 947, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 827, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 735, 41),
      ))
    }

@delegate:ResourceContentHash(-838_387_946)
internal val Res.string.events_filter_family: StringResource by lazy {
      StringResource("string:events_filter_family", "events_filter_family", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 993, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 869, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 777, 36),
      ))
    }

@delegate:ResourceContentHash(129_066_643)
internal val Res.string.events_filter_free: StringResource by lazy {
      StringResource("string:events_filter_free", "events_filter_free", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1042, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 910, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 814, 34),
      ))
    }

@delegate:ResourceContentHash(-1_946_340_141)
internal val Res.string.events_filter_music: StringResource by lazy {
      StringResource("string:events_filter_music", "events_filter_music", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1085, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 949, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 849, 35),
      ))
    }

@delegate:ResourceContentHash(-933_721_785)
internal val Res.string.events_filter_week: StringResource by lazy {
      StringResource("string:events_filter_week", "events_filter_week", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1129, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 989, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 885, 38),
      ))
    }

@delegate:ResourceContentHash(129_066_643)
internal val Res.string.events_free: StringResource by lazy {
      StringResource("string:events_free", "events_free", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1176, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1036, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 924, 27),
      ))
    }

@delegate:ResourceContentHash(458_046_163)
internal val Res.string.events_get_free_tickets: StringResource by lazy {
      StringResource("string:events_get_free_tickets", "events_get_free_tickets", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1212, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1068, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 952, 55),
      ))
    }

@delegate:ResourceContentHash(-235_338_539)
internal val Res.string.events_going: StringResource by lazy {
      StringResource("string:events_going", "events_going", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1335, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1175, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1051, 28),
      ))
    }

@delegate:ResourceContentHash(203_008_036)
internal val Res.string.events_going_count: StringResource by lazy {
      StringResource("string:events_going_count", "events_going_count", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1272, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1124, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1008, 42),
      ))
    }

@delegate:ResourceContentHash(-674_822_314)
internal val Res.string.events_im_going: StringResource by lazy {
      StringResource("string:events_im_going", "events_im_going", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1376, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1212, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1080, 39),
      ))
    }

@delegate:ResourceContentHash(-740_532_473)
internal val Res.string.events_image_a11y: StringResource by lazy {
      StringResource("string:events_image_a11y", "events_image_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1420, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1252, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1120, 53),
      ))
    }

@delegate:ResourceContentHash(1_780_990_508)
internal val Res.string.events_link_unavailable: StringResource by lazy {
      StringResource("string:events_link_unavailable", "events_link_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1486, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1314, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1174, 63),
      ))
    }

@delegate:ResourceContentHash(1_974_682_995)
internal val Res.string.events_month_apr: StringResource by lazy {
      StringResource("string:events_month_apr", "events_month_apr", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1578, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1390, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1238, 28),
      ))
    }

@delegate:ResourceContentHash(1_923_991_656)
internal val Res.string.events_month_aug: StringResource by lazy {
      StringResource("string:events_month_aug", "events_month_aug", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1619, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1423, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1267, 28),
      ))
    }

@delegate:ResourceContentHash(351_471_452)
internal val Res.string.events_month_dec: StringResource by lazy {
      StringResource("string:events_month_dec", "events_month_dec", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1652, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1456, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1296, 28),
      ))
    }

@delegate:ResourceContentHash(1_606_773_862)
internal val Res.string.events_month_feb: StringResource by lazy {
      StringResource("string:events_month_feb", "events_month_feb", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1693, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1489, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1325, 28),
      ))
    }

@delegate:ResourceContentHash(-1_882_672_462)
internal val Res.string.events_month_jan: StringResource by lazy {
      StringResource("string:events_month_jan", "events_month_jan", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1734, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1522, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1354, 28),
      ))
    }

@delegate:ResourceContentHash(1_573_735_379)
internal val Res.string.events_month_jul: StringResource by lazy {
      StringResource("string:events_month_jul", "events_month_jul", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1775, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1555, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1383, 28),
      ))
    }

@delegate:ResourceContentHash(119_241_428)
internal val Res.string.events_month_jun: StringResource by lazy {
      StringResource("string:events_month_jun", "events_month_jun", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1816, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1588, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1412, 28),
      ))
    }

@delegate:ResourceContentHash(1_133_985_384)
internal val Res.string.events_month_mar: StringResource by lazy {
      StringResource("string:events_month_mar", "events_month_mar", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1853, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1621, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1441, 28),
      ))
    }

@delegate:ResourceContentHash(1_300_979_400)
internal val Res.string.events_month_may: StringResource by lazy {
      StringResource("string:events_month_may", "events_month_may", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1890, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1654, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1470, 28),
      ))
    }

@delegate:ResourceContentHash(1_698_851_746)
internal val Res.string.events_month_nov: StringResource by lazy {
      StringResource("string:events_month_nov", "events_month_nov", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1923, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1683, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1499, 28),
      ))
    }

@delegate:ResourceContentHash(-599_276_678)
internal val Res.string.events_month_oct: StringResource by lazy {
      StringResource("string:events_month_oct", "events_month_oct", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1964, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1716, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1528, 28),
      ))
    }

@delegate:ResourceContentHash(-2_001_820_811)
internal val Res.string.events_month_sep: StringResource by lazy {
      StringResource("string:events_month_sep", "events_month_sep", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2005, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1749, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1557, 28),
      ))
    }

@delegate:ResourceContentHash(2_111_656_951)
internal val Res.string.events_pm: StringResource by lazy {
      StringResource("string:events_pm", "events_pm", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2050, 25),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1782, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1586, 21),
      ))
    }

@delegate:ResourceContentHash(-2_029_959_231)
internal val Res.string.events_retry: StringResource by lazy {
      StringResource("string:events_retry", "events_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2076, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1804, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1608, 32),
      ))
    }

@delegate:ResourceContentHash(1_331_689_701)
internal val Res.string.events_share_a11y: StringResource by lazy {
      StringResource("string:events_share_a11y", "events_share_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2125, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1841, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1641, 41),
      ))
    }

@delegate:ResourceContentHash(1_684_707_708)
internal val Res.string.events_sort_label: StringResource by lazy {
      StringResource("string:events_sort_label", "events_sort_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2191, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1899, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1683, 33),
      ))
    }

@delegate:ResourceContentHash(-463_565_511)
internal val Res.string.events_sort_recommended: StringResource by lazy {
      StringResource("string:events_sort_recommended", "events_sort_recommended", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2245, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1933, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1717, 47),
      ))
    }

@delegate:ResourceContentHash(1_340_164_720)
internal val Res.string.events_sort_soonest: StringResource by lazy {
      StringResource("string:events_sort_soonest", "events_sort_soonest", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2301, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1981, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1765, 39),
      ))
    }

@delegate:ResourceContentHash(2_056_527_487)
internal val Res.string.events_subtitle: StringResource by lazy {
      StringResource("string:events_subtitle", "events_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2349, 151),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2021, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1805, 87),
      ))
    }

@delegate:ResourceContentHash(479_388_077)
internal val Res.string.events_tickets_organizer: StringResource by lazy {
      StringResource("string:events_tickets_organizer", "events_tickets_organizer", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2501, 104),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2133, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1893, 68),
      ))
    }

@delegate:ResourceContentHash(725_148_440)
internal val Res.string.events_title: StringResource by lazy {
      StringResource("string:events_title", "events_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2606, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2218, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1962, 28),
      ))
    }

@delegate:ResourceContentHash(659_202)
internal val Res.string.events_upcoming: StringResource by lazy {
      StringResource("string:events_upcoming", "events_upcoming", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2651, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2255, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1991, 43),
      ))
    }

@delegate:ResourceContentHash(1_336_464_438)
internal val Res.string.events_venue_format: StringResource by lazy {
      StringResource("string:events_venue_format", "events_venue_format", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2715, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2307, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2035, 43),
      ))
    }

@delegate:ResourceContentHash(-443_794_307)
internal val Res.string.events_view_details: StringResource by lazy {
      StringResource("string:events_view_details", "events_view_details", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2759, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2351, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2079, 43),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.tickets_back_a11y: StringResource by lazy {
      StringResource("string:tickets_back_a11y", "tickets_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2823, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2403, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2123, 33),
      ))
    }

@delegate:ResourceContentHash(357_898_634)
internal val Res.string.tickets_claim_cta: StringResource by lazy {
      StringResource("string:tickets_claim_cta", "tickets_claim_cta", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2865, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2437, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2157, 49),
      ))
    }

@delegate:ResourceContentHash(1_720_992_660)
internal val Res.string.tickets_claim_failed: StringResource by lazy {
      StringResource("string:tickets_claim_failed", "tickets_claim_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2939, 180),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2503, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2207, 108),
      ))
    }

@delegate:ResourceContentHash(-1_119_915_627)
internal val Res.string.tickets_claim_title: StringResource by lazy {
      StringResource("string:tickets_claim_title", "tickets_claim_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3120, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2636, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2316, 43),
      ))
    }

@delegate:ResourceContentHash(93_346_040)
internal val Res.string.tickets_error: StringResource by lazy {
      StringResource("string:tickets_error", "tickets_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3176, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2692, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2360, 53),
      ))
    }

@delegate:ResourceContentHash(655_952_714)
internal val Res.string.tickets_free_note: StringResource by lazy {
      StringResource("string:tickets_free_note", "tickets_free_note", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3266, 213),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2762, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2414, 137),
      ))
    }

@delegate:ResourceContentHash(602_167_037)
internal val Res.string.tickets_party_size: StringResource by lazy {
      StringResource("string:tickets_party_size", "tickets_party_size", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3480, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2928, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2552, 46),
      ))
    }

@delegate:ResourceContentHash(-289_112_949)
internal val Res.string.tickets_qr_a11y: StringResource by lazy {
      StringResource("string:tickets_qr_a11y", "tickets_qr_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3539, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2975, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2599, 43),
      ))
    }

@delegate:ResourceContentHash(-1_317_410_795)
internal val Res.string.tickets_qty_label: StringResource by lazy {
      StringResource("string:tickets_qty_label", "tickets_qty_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3587, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3023, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2643, 49),
      ))
    }

@delegate:ResourceContentHash(-574_583_101)
internal val Res.string.tickets_retry: StringResource by lazy {
      StringResource("string:tickets_retry", "tickets_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3633, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3077, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2693, 33),
      ))
    }

@delegate:ResourceContentHash(295_612_083)
internal val Res.string.tickets_sold_out: StringResource by lazy {
      StringResource("string:tickets_sold_out", "tickets_sold_out", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3671, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3107, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2727, 44),
      ))
    }

@delegate:ResourceContentHash(1_797_861_069)
internal val Res.string.tickets_status_refunded: StringResource by lazy {
      StringResource("string:tickets_status_refunded", "tickets_status_refunded", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3720, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3152, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2772, 43),
      ))
    }

@delegate:ResourceContentHash(-1_084_731_522)
internal val Res.string.tickets_status_used: StringResource by lazy {
      StringResource("string:tickets_status_used", "tickets_status_used", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3788, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3200, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2816, 35),
      ))
    }

@delegate:ResourceContentHash(134_168_887)
internal val Res.string.tickets_status_valid: StringResource by lazy {
      StringResource("string:tickets_status_valid", "tickets_status_valid", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3848, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3240, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2852, 36),
      ))
    }

@delegate:ResourceContentHash(-1_621_190_861)
internal val Res.string.tickets_wallet_empty_desc: StringResource by lazy {
      StringResource("string:tickets_wallet_empty_desc", "tickets_wallet_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3893, 209),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3277, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2889, 121),
      ))
    }

@delegate:ResourceContentHash(526_372_210)
internal val Res.string.tickets_wallet_empty_title: StringResource by lazy {
      StringResource("string:tickets_wallet_empty_title", "tickets_wallet_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4103, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3415, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3011, 54),
      ))
    }

@delegate:ResourceContentHash(-1_930_098_991)
internal val Res.string.tickets_wallet_title: StringResource by lazy {
      StringResource("string:tickets_wallet_title", "tickets_wallet_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4182, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3466, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3066, 44),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("events_am", Res.string.events_am)
  map.put("events_back_a11y", Res.string.events_back_a11y)
  map.put("events_date_time_format", Res.string.events_date_time_format)
  map.put("events_detail_about", Res.string.events_detail_about)
  map.put("events_detail_to", Res.string.events_detail_to)
  map.put("events_detail_when", Res.string.events_detail_when)
  map.put("events_detail_where", Res.string.events_detail_where)
  map.put("events_details_external", Res.string.events_details_external)
  map.put("events_empty_description", Res.string.events_empty_description)
  map.put("events_empty_title", Res.string.events_empty_title)
  map.put("events_error", Res.string.events_error)
  map.put("events_featured", Res.string.events_featured)
  map.put("events_featured_section", Res.string.events_featured_section)
  map.put("events_filter_all", Res.string.events_filter_all)
  map.put("events_filter_business", Res.string.events_filter_business)
  map.put("events_filter_culture", Res.string.events_filter_culture)
  map.put("events_filter_family", Res.string.events_filter_family)
  map.put("events_filter_free", Res.string.events_filter_free)
  map.put("events_filter_music", Res.string.events_filter_music)
  map.put("events_filter_week", Res.string.events_filter_week)
  map.put("events_free", Res.string.events_free)
  map.put("events_get_free_tickets", Res.string.events_get_free_tickets)
  map.put("events_going", Res.string.events_going)
  map.put("events_going_count", Res.string.events_going_count)
  map.put("events_im_going", Res.string.events_im_going)
  map.put("events_image_a11y", Res.string.events_image_a11y)
  map.put("events_link_unavailable", Res.string.events_link_unavailable)
  map.put("events_month_apr", Res.string.events_month_apr)
  map.put("events_month_aug", Res.string.events_month_aug)
  map.put("events_month_dec", Res.string.events_month_dec)
  map.put("events_month_feb", Res.string.events_month_feb)
  map.put("events_month_jan", Res.string.events_month_jan)
  map.put("events_month_jul", Res.string.events_month_jul)
  map.put("events_month_jun", Res.string.events_month_jun)
  map.put("events_month_mar", Res.string.events_month_mar)
  map.put("events_month_may", Res.string.events_month_may)
  map.put("events_month_nov", Res.string.events_month_nov)
  map.put("events_month_oct", Res.string.events_month_oct)
  map.put("events_month_sep", Res.string.events_month_sep)
  map.put("events_pm", Res.string.events_pm)
  map.put("events_retry", Res.string.events_retry)
  map.put("events_share_a11y", Res.string.events_share_a11y)
  map.put("events_sort_label", Res.string.events_sort_label)
  map.put("events_sort_recommended", Res.string.events_sort_recommended)
  map.put("events_sort_soonest", Res.string.events_sort_soonest)
  map.put("events_subtitle", Res.string.events_subtitle)
  map.put("events_tickets_organizer", Res.string.events_tickets_organizer)
  map.put("events_title", Res.string.events_title)
  map.put("events_upcoming", Res.string.events_upcoming)
  map.put("events_venue_format", Res.string.events_venue_format)
  map.put("events_view_details", Res.string.events_view_details)
  map.put("tickets_back_a11y", Res.string.tickets_back_a11y)
  map.put("tickets_claim_cta", Res.string.tickets_claim_cta)
  map.put("tickets_claim_failed", Res.string.tickets_claim_failed)
  map.put("tickets_claim_title", Res.string.tickets_claim_title)
  map.put("tickets_error", Res.string.tickets_error)
  map.put("tickets_free_note", Res.string.tickets_free_note)
  map.put("tickets_party_size", Res.string.tickets_party_size)
  map.put("tickets_qr_a11y", Res.string.tickets_qr_a11y)
  map.put("tickets_qty_label", Res.string.tickets_qty_label)
  map.put("tickets_retry", Res.string.tickets_retry)
  map.put("tickets_sold_out", Res.string.tickets_sold_out)
  map.put("tickets_status_refunded", Res.string.tickets_status_refunded)
  map.put("tickets_status_used", Res.string.tickets_status_used)
  map.put("tickets_status_valid", Res.string.tickets_status_valid)
  map.put("tickets_wallet_empty_desc", Res.string.tickets_wallet_empty_desc)
  map.put("tickets_wallet_empty_title", Res.string.tickets_wallet_empty_title)
  map.put("tickets_wallet_title", Res.string.tickets_wallet_title)
}
